import script from "./DashboardNext.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardNext.vue?vue&type=script&setup=true&lang=js"

import "./DashboardNext.vue?vue&type=style&index=0&id=08d21b02&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08d21b02"]])

export default __exports__